export const ScreenInInitCallbackSymbol = Symbol('ScreenIn')
export const ScreenInAPISymbol = Symbol('ScreenInAPI')

export const name = 'screenIn' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'

export const SCREEN_IN_CALLBACK = 'screenInCallback'
